import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom"; // Import useNavigate
import "../StyleComponent/PopupForm.css";

import upiQRImage from "../Assets/BankQR.png";
import posImage from "../Assets/POS.png";
import soundboxImage from "../Assets/Soundbox.png";
import paymentGatewayImage from "../Assets/payment.png";
import CustomDropdown from "./CustomDropdown";
import { useCookies } from "react-cookie";
import { callLSQLapp, encryptBody, getLsqLeadBody } from "../services/lsq";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import queryString from "query-string";


const PopupForm = ({
  solution,
  selectedSolutions,
  onClose,
  onSolutionSelect,
  setSelectedSolutions,
  handleClose, // Ensure this is passed if needed
}) => {
  const navigate = useNavigate(); // Define navigate here
  const [errors, setErrors] = useState({});
  const [fbp, setFbp] = useState("");
  const [fbc, setFbc] = useState("");
  const [cookies, setCookie] = useCookies();
  const [token, setToken] = useState("");
  const [otpSent1, setOtpSent1] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const [size, setSize] = useState(0);
  const [size1, setSize1] = useState(0);
  const selectRef = useRef(null);
  const selectRef1 = useRef(null);

  // Function to handle focus event
  // const handleFocus = () => setSize(4);
  // const handleBlur = () => setSize(0);

  // const handleFocus1 = () => setSize1(4);
  // const handleBlur1 = () => setSize1(0);
  const [selectedBusinessSegment, setSelectedBusinessSegment] = useState("");
  const [selectedAnnualTurnover, setSelectedAnnualTurnover] = useState("");

  const [hasAccount, setHasAccount] = useState("Yes");

  useEffect(() => {
    setFbp(cookies["_fbp"] || "");
    setFbc(cookies["_fbc"] || "");
  }, []);

  const [formData, setFormData] = useState({
    fullName: "",
    mobileNumber: "",
    email: "",
    businessName: "",
    businessSegment: "",
    annualTurnover: "",
    accountNumber: "",
    agreeToTerms: true,
    CampaignId: "999777",
    CompleteUrl: window.location.href,
    ApiProductName: "Merchant Solutions",
    FBPixelID: fbp,
    FBClickID: fbc,
    subProduct: "Merchant Solutions",
    source: "Landing Page",
    token: token,
    interestedProduct: selectedSolutions,

  });

  const [otpSent, setOtpSent] = useState(false);
  const [timer, setTimer] = useState(60);
  const [isMobileValid, setIsMobileValid] = useState(false);

  const sendOTP = async () => {
    try {
      let payload = { mobile: formData.mobileNumber, messageType: "otpGeneral" };
      let param = { otp: "send", productType: "BG", autoReadOtp: "yes" };
      const otpResponse = await callLSQLapp(payload, "OTP", param);
      setOtpSent1(true);
      if (otpResponse.data.message.response.sent) {
        toast.success("OTP has been sent to your mobile number.");
        setOtpSent(true);
        setTimer(60); // Reset timer to 60 seconds
        const interval = setInterval(() => {
          setTimer((prev) => {
            if (prev === 1) {
              clearInterval(interval);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      } else if (otpResponse.data.message.response === "MAX OTP Limit reached") {
        window.alert("OTP Limit reached, try again after 5 minutes");
        window.location.reload();
      }
      else {
        toast.warn("Please Resend OTP.");
        setTimer(60)
      }
    } catch (error) {
      alert(
        "Error occurred while generating OTP. please Refresh the page and try again"
      );
    }
  }
  const handleSendOTP = async () => {
    if (formData.mobileNumber.length === 10) {
      // Simulate OTP sending (you'll need to implement actual OTP API call)
      await sendOTP();

    }
  };

  // Handle Verify OTP
  const handleVerifyOTP = async () => {


    if (otp.length == 6) {
      try {
        let payload = { mobile: formData.mobileNumber, otp: otp.join('') };
        let param = { otp: "verify", productType: "BG" };
        const otpVerifyResponse = await callLSQLapp(payload, "OTP", param);
        // const res = await onVerifyOtp(mobileNo, OTP);
        if (
          otpVerifyResponse.data.message ===
          "Failure Occured, please check logs"
        ) {
          setOtp(new Array(6).fill(""));

          document.getElementById(`otp-input-${0}`).focus();

          toast.warn("Please enter valid OTP");
          setErrors({ ...errors, otp: 'Invalid OTP' });
          return false;
        } else {
          toast.success("OTP Verified");
          const tokenValue =
            otpVerifyResponse.data.message.response.dataSent.UniqueID;
          setToken(tokenValue);
          setOtpVerified(true);
          setTimer(0);
        }
      } catch (error) {
        console.log("error in verify OTP", error)
      }
    }

  };

  // Handle Resend OTP
  const handleResendOTP = async () => {
    await sendOTP();
  };

  const [otp, setOtp] = useState(new Array(6).fill(""));

  const handleOTPChange = (e, index) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {  // केवल digits की अनुमति है
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // अगले input पर स्विच करें
      if (value && index < 5) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }


    }
  };

  const handleBackspace = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      // पिछले input पर स्विच करें
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  //  Logger
  // useEffect(() => {
  //   console.log(formData)
  // },[formData])

  // ALERT: This useEffect calls itself infinitely.

  // useEffect(() => {
  //   if (solution) {
  //     // Ensure the solution is reflected in the popup
  //     if (!selectedSolutions.includes(solution.id)) {
  //       onSolutionSelect(solution.id);
  //     }
  //   }

  // }, [solution, onSolutionSelect]);

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;

    // Collapse dropdown and trigger blur to close
    if (name === "businessSegment") {
      setSize(0); // Collapse the dropdown for businessSegment
      if (selectRef.current) {
        selectRef.current.blur(); // Blur to close dropdown
      }
    } else if (name === "annualTurnover") {
      setSize1(0); // Collapse the dropdown for annualTurnover
      if (selectRef1.current) {
        selectRef1.current.blur(); // Blur to close dropdown
      }
    }

    if (name === "fullName" || name === "businessName") {
      if (/^[a-zA-Z\s]*$/.test(value)) {
        setFormData({
          ...formData,
          [name]: value,
        });
        setErrors({ ...errors, [name]: "" }); // Clear error message
      } else {
        setErrors({
          ...errors,
          [name]: "Only alphabets and spaces are allowed.",
        });
      }
    } else if (name === "mobileNumber") {
      if (/^\d*$/.test(value) && value.length <= 10) {
        setFormData({
          ...formData,
          [name]: value,
        });
        setErrors({ ...errors, [name]: "" }); // Clear error message
      } else {
        setErrors({
          ...errors,
          [name]: "Please enter a valid mobile number (10 digits).",
        });
      }
      if (name === 'mobileNumber') {
        const isValid = /^\d{10}$/.test(value);
        setIsMobileValid(isValid);
        if (!isValid) {
          setErrors({ ...errors, mobileNumber: 'Please enter a valid mobile number.' });
        } else {
          setErrors({ ...errors, mobileNumber: '' });
        }
      }
    } else if (name === "accountNumber") {
      if (/^\d*$/.test(value) && value.length <= 12) {
        setFormData({
          ...formData,
          [name]: value,
        });
        setErrors({ ...errors, [name]: "" }); // Clear error message
      } else {
        setErrors({
          ...errors,
          [name]: "Please enter a valid account number (12 digits).",
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value,
      });
      setErrors({ ...errors, [name]: "" }); // Clear error message
    }
  };
  const validateForm = () => {
    const {
      fullName,
      mobileNumber,
      email,
      businessName,
      businessSegment,
      annualTurnover,
      accountNumber,
      agreeToTerms,
    } = formData;

    const mobileRegex = /^[0-9]{10}$/;
    const accountNumberRegex = /^[0-9]{12}$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    let newErrors = {};


    if (selectedSolutions.length === 0) {
      newErrors.selectedSolutions =
        "Please select at least one payment solution.";
      alert("Please select at least one payment solution.");
    }

    if (!fullName) newErrors.fullName = "Please enter your Full Name.";
    if (!mobileNumber)
      newErrors.mobileNumber = "Please enter your Mobile Number.";
    if (!email) newErrors.email = "Please enter your Email Address.";
    if (!businessName)
      newErrors.businessName = "Please enter your Business Name.";
    if (!businessSegment)
      newErrors.businessSegment = "Please select your Business Segment.";
    if (!annualTurnover)
      newErrors.annualTurnover = "Please select your Annual Turnover.";
    if (!agreeToTerms)
      newErrors.agreeToTerms = "Please agree to the terms and conditions.";

    if (mobileNumber && !mobileRegex.test(mobileNumber)) {
      newErrors.mobileNumber = "Please enter a valid 10-digit mobile number.";
    }

    if (email && !emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email address.";
    }

    if (hasAccount === "Yes" && !accountNumber) {
      newErrors.accountNumber = "Account number is required.";
    }

    if (accountNumber && !accountNumberRegex.test(accountNumber)) {
      newErrors.accountNumber = "Please enter a valid 12-digit account number.";
    }

    if (businessName && /[\d]/.test(businessName)) {
      newErrors.businessName = "Business Name should not contain numbers.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const businessSegments = [
    { value: "Agriculture Services", label: "Agriculture Services" },
    { value: "B2B", label: "B2B" },
    { value: "Charity/ NGO/ Religious Entity", label: "Charity/ NGO/ Religious Entity" },
    { value: "Education", label: "Education" },
    { value: "Financial Services/ NBFC", label: "Financial Services/ NBFC" },
    { value: "Food And Beverage", label: "Food And Beverage" },
    { value: "Fuel", label: "Fuel" },
    { value: "Government/ PSU/ Defence", label: "Government/ PSU/ Defence" },
    { value: "Grocery/ Supermarket", label: "Grocery/ Supermarket" },
    { value: "Health Services", label: "Health Services" },
    { value: "Hotels And Lodging", label: "Hotels And Lodging" },
    { value: "Insurance", label: "Insurance" },
    { value: "Miscellaneous", label: "Miscellaneous" },
    { value: "Other Services", label: "Other Services" },
    { value: "Pharmacy", label: "Pharmacy" },
    { value: "Property Management", label: "Property Management" },
    { value: "Retail/ E-Commerce", label: "Retail/ E-Commerce" },
    { value: "Tours & Travel", label: "Tours & Travel" },
    { value: "Transportation Services", label: "Transportation Services" },
    { value: "Utility Services", label: "Utility Services" }
  ];

  const annualTurnovers = [

    { value: "0-20L", label: "Up to ₹20 Lakhs" },
    { value: "20L-40L", label: "₹20 Lakhs - ₹40 Lakhs" },
    { value: "40L-1Cr", label: "₹40 Lakhs - ₹1 Crore" },
    { value: "1Cr-5Cr", label: "₹1 Crore - ₹5 Crore" },
    { value: "5Cr-10Cr", label: "₹5 Crore - ₹10 Crore" },
    { value: "10Cr+", label: "More than ₹10 Crore" }
  ];

  // const filteredBusinessSegments = businessSegments.filter(
  //   (segment) => segment.value !== formData.businessSegment
  // );

  // const filteredAnnualTurnovers = annualTurnovers.filter(
  //   (turnover) => turnover.value !== formData.annualTurnover
  // );

  const handleSubmit = async (event) => {
    event.preventDefault();


    const validate = validateForm();

    if (validate && otpVerified) {
      // GET UTM DETAILS
      const utmParamsObj = queryString.parse(window.location.search);
      const utmObj = {};
      for (const [key, value] of Object.entries(utmParamsObj)) {
        utmObj[key] = value;
      }
      const [firstName, lastName] = formData.fullName.split(' ')
      const formBody = { ...formData, ...utmObj, mobile: formData.mobileNumber, token: token, firstName: firstName, lastName: lastName || "", interestedProduct: selectedSolutions.join(), terms: "Yes", hasAccount: hasAccount }

      const lsqInputs = getLsqLeadBody(formBody);
      const payload = {
        mobile: formData.mobileNumber,
        otp: otp.join(''),
        formdata: lsqInputs,
      };

      console.log("Lead Create Payload: ", payload);

      setFormSubmitted(true)
      const encryptedPayload = await encryptBody(payload);
      const createLeadResp = await callLSQLapp(encryptedPayload, "CREATE", { productType: "BG" });

      if (createLeadResp.data.message !== "Failure occured , please check logs") {
        let leadid = createLeadResp.data.message.Data.LeadApiCalls.Message.Id;
        navigate(`/IciciThanks?leadId=${leadid}`);
      } else {
        setFormSubmitted(false);
        console.log("lead not created.");
        window.alert("Some error ocuured. Please try again after 5 minutes.")
      }

    }
  };

  const handleToggleSelect = (solutionId) => {
    onSolutionSelect(solutionId); // This should update the selectedSolutions in the parent component
  };

  const handleSolutionSelect = (solutionId) => {

    setSelectedSolutions((prev) => {
      if (prev.includes(solutionId)) {
        return prev.filter((id) => id !== solutionId);
      } else {
        return [...prev, solutionId];
      }
    });
  };

  // Pass `handleSolutionSelect` to `PopupForm`
  <PopupForm
    solution={solution}
    selectedSolutions={selectedSolutions}
    onClose={handleClose}
    onSolutionSelect={handleSolutionSelect}
  />;

  const SolutionCard = ({ id, name, description, isSelected, image }) => {
    return (
      <div
        className={`solution-card ${isSelected ? "selected" : ""}`}
        onClick={() => handleToggleSelect(id)}
      >
        <img src={image} alt={name} />
        <h3>{name}</h3>
        <p className='paragraf'>{description}</p>
        <div className='toggle'>
          <div className={`toggle-slider ${isSelected ? "active" : ""}`}></div>
          {!isSelected && <span className='toggle-text'>Select</span>}
        </div>
      </div>
    );
  };

  return (
    <>
      <ToastContainer />
      <div className='popup-overlay'>
        <div className='popup-content'>
          <div style={{ backgroundColor: "white", zIndex: 100 }}>
            <header className='icici-header' >
              {/* <img
                src={require("../Assets/logo.png")}
                alt='ICICI Bank'
                className='icici-logo'
              /> */}
            </header>
          </div>

          <div className='payment-solutions'>
            <div
              style={{
                backgroundColor: "white",
                zIndex: 100,
                position: "relative",
              }}
              className='choose1'
            >
              <button
                className='close-btn'
                style={{
                  top: 0,
                  right: 0,
                  zIndex: 9999999999,
                }}
                onClick={onClose}
              >
                ×
              </button>
              <h1 className='choose'>
                Provide details to proceed with choice of solution(s)
              </h1>
            </div>

            <div className='solution-grid'>
              {solutions.map((solution) => (
                <SolutionCard
                  key={solution.id}
                  {...solution}
                  isSelected={selectedSolutions.includes(solution.id)}
                  onSelect={handleToggleSelect}
                />
              ))}
            </div>
            {/* {errors.fullName && (
                <p style={{ color: "red" }}>{errors.selectedSolutions}</p>
              )} */}
          </div>
          <main className='icici-main'>
            <form className='icici-form' onSubmit={handleSubmit}>
              <div className='form-section'>
                <input
                  type='text'
                  name='fullName'
                  placeholder='Full Name'
                  className='section5 custom-placeholder'
                  value={formData.fullName}
                  onChange={handleInputChange}
                // required
                />
                {errors.fullName && <p className='error1'>{errors.fullName}</p>}

                <input
                  type='tel'
                  name='mobileNumber'
                  placeholder='Mobile Number'
                  className='section2 custom-placeholder'
                  value={formData.mobileNumber}
                  onChange={handleInputChange}
                  required
                />
                {errors.mobileNumber && <p className='error2'>{errors.mobileNumber}</p>}

                {/* OTP Button and Inputs */}
                <div className='otp_section'>
                  {!otpSent1 && <button className="otp_button send-btn" type='button' onClick={handleSendOTP} disabled={!isMobileValid}>
                    Send OTP
                  </button>}

                  {otpSent && (
                    <div className='otp-container'>
                      <div className="otp-inputs">
                        {[...Array(6)].map((_, index) => (
                          <input
                            key={index}
                            id={`otp-input-${index}`}
                            type="text"
                            maxLength="1"
                            className="otp-box"
                            value={otp[index]}
                            onChange={(e) => handleOTPChange(e, index)}
                            disabled={otpVerified}
                          />
                        ))}
                      </div>
                      {otp?.every((digit) => digit !== "") && !otpVerified && (
                        <button
                          className="otp_button verify-btn"
                          type='button'
                          onClick={handleVerifyOTP}
                        >
                          Verify OTP
                        </button>
                      )}
                      {timer > 0 ? (
                        <p>{timer} sec</p>
                      ) : (
                        !otpVerified && <button className="otp_button resend-btn" onClick={handleResendOTP}>Resend OTP</button>
                      )}
                      {errors.otp && <p className='error2'>{errors.otp}</p>}
                    </div>
                  )}
                </div>
                <input
                  type='email'
                  name='email'
                  placeholder='Email Address'
                  className='section2 custom-placeholder'
                  value={formData.email}
                  onChange={handleInputChange}
                // required
                />
                {errors.email && <p className='error5'>{errors.email}</p>}
              </div>
              <div className='form-section1'>
                <input
                  type='text'
                  name='businessName'
                  placeholder='Business Name'
                  className='section1 custom-placeholder'
                  value={formData.businessName}
                  onChange={handleInputChange}

                // required
                />
                {errors.businessName && (
                  <p className='error2'>{errors.businessName}</p>
                )}

                <div className='dropdown-container1' dir='rtl'>
                  <CustomDropdown
                    options={businessSegments}
                    selectedValue={selectedBusinessSegment}
                    onSelect={(value) => {
                      setSelectedBusinessSegment(value);
                      setFormData({
                        ...formData,
                        businessSegment: value,
                      });
                    }}
                    placeholder='Select Business Segment'
                    className='section1'
                  />
                </div>
                {errors.businessSegment && (
                  <p className='error3'>{errors.businessSegment}</p>
                )}

                <div className='dropdown-container'>
                  <CustomDropdown
                    options={annualTurnovers}
                    selectedValue={selectedAnnualTurnover}
                    onSelect={(value) => {
                      setSelectedAnnualTurnover(value);
                      setFormData({
                        ...formData,
                        annualTurnover: value,
                      });
                    }}
                    placeholder='Select Annual Turnover'
                  />
                </div>
                {errors.annualTurnover && (
                  <p className='error4'>{errors.annualTurnover}</p>
                )}
              </div>
              <div className='form-section3 account-section'>
                <p className='custom-paragraph'>
                  Do you have an ICICI Bank Current Account?
                </p>
                <div className='radio-group'>
                  <label>
                    <input
                      type='radio'
                      name='hasAccount'
                      value='Yes'
                      checked={hasAccount === "Yes"}
                      onChange={() => setHasAccount("Yes")}
                    />

                    <span className='span1'>Yes</span>
                  </label>

                  <label>
                    <input
                      type='radio'
                      name='hasAccount'
                      value='No'
                      checked={hasAccount === "No"}
                      onChange={() => setHasAccount("No")}
                    />
                    <span className='span1'>No</span>
                  </label>
                </div>
                {hasAccount === "Yes" && (
                  <input
                    type='text'
                    name='accountNumber'
                    placeholder=' Account No.'
                    className='section2 custom-placeholder'
                    value={formData.accountNumber}
                    onChange={handleInputChange}
                  />
                )}
                {hasAccount === "Yes" && errors.accountNumber && (
                  <p className='error6'>{errors.accountNumber}</p>
                )}
              </div>
              <div className='section3'>
                <label className='checkbox-container'>
                  <input
                    type='checkbox'
                    name='agreeToTerms'
                    style={{ height: "50px", width: "50px" }}
                    checked={formData.agreeToTerms}
                    onChange={handleInputChange}
                  // required
                  />

                  <span className='checkmark'></span>
                  <p className='consent-text'>
                    I authorize ICICI Bank and its representatives to contact me
                    through phone, email, SMS, and WhatsApp.
                  </p>
                </label>
                {/* {errors.agreeToTerms && (
                  <p className="error2">{errors.agreeToTerms}</p>
                )} */}
              </div>
              <button type='submit' className='submit-btn' disabled={formSubmitted}>
                {!formSubmitted ? "Submit" : "Processing"}
              </button>
            </form>
            <footer className='icici-footer'>
              <p>
                *Terms and Conditions of ICICI Bank apply. For details{" "}
                <Link to='/ClickHere'>Click Here.</Link>
              </p>
              <p>
                Corporate Office Address: ICICI Bank Towers, Bandra-Kurla
                Complex, Mumbai 400 051
              </p>
            </footer>
          </main>
        </div>
      </div>
    </>
  );
};

const solutions = [
  {
    id: "upi_qr",
    name: "UPI QR",
    image: upiQRImage,
  },
  {
    id: "pos",
    name: "POS",
    image: posImage,
  },
  {
    id: "soundbox",
    name: "SoundBox",
    image: soundboxImage,
  },
  {
    id: "payment_gateway",
    name: "Payment Link",
    image: paymentGatewayImage,
  },
];
export default PopupForm;
